import Image from 'next/image';
import React, { useState } from "react";
import IMAGES from '../../public/assets/img/index';


const images = [
  { src: IMAGES.BRANDIMG.twiga, alt: "Twiga" },
  { src: IMAGES.BRANDIMG.lucro, alt: "Lucro" },
  { src: IMAGES.BRANDIMG.foodlogo, alt: "Food Logo" },
  { src: IMAGES.BRANDIMG.logocompany, alt: "AEP" },
  { src: IMAGES.BRANDIMG.aditya, alt: "Aditya" },
];

const chunkArray = (arr, size) =>
  Array.from({ length: Math.ceil(arr.length / size) }, (_, i) =>
    arr.slice(i * size, i * size + size)
  );


const BrandCarousel=()=>{
 
  const slides = chunkArray(images, 2);
  const [activeIndex, setActiveIndex] = useState(0);

  const goToSlide = (index) => {
    const next = (index + slides.length) % slides.length;
    setActiveIndex(next);
  };

   
    return (
      <div className='py-20 lg:py-sp-100' data-aos="fade-up" data-aos-duration="500" data-aos-once="true">
          <div className='container xm:px-2 px-3  lg:px-3'>
          <h2 className='text-center text-xxxl text-secondary font-normal mb-6'>Credlix works with the best enterprises in the business</h2>
              <div className='relative max-w-[850px] w-full m-auto'>
                 
      {/* Desktop Grid */}
      <div className="sm:hidden flex gap-2 max-w-5xl mx-auto">
        {images.map((img, i) => (
          <div key={i} className="flex justify-center items-center p-1">
            <Image
              src={img.src}
              width={200}
              height={200}
              alt={img.alt}
              className="object-contain bg-white rounded-md"
            />
          </div>
        ))}
      </div>

      {/* Mobile Slider */}
          <div className="hidden sm:block py-6">
          {/* Carousel */}
          <div className="overflow-hidden relative">
            <div
              className="flex transition-transform duration-500"
              style={{
                transform: `translateX(-${activeIndex * 100}%)`,
                // width: `${slides.length * 100}%`,
              }}
            >
              {slides.map((pair, idx) => (
                <div key={idx} className="w-full flex justify-around shrink-0">
                  {pair.map((img, i) => (
                    <Image
                      key={i}
                      src={img.src}
                      alt={img.alt}
                      width={150}
                      height={150}
                      className="rounded-md object-contain bg-white"
                    />
                  ))}
                </div>
              ))}
            </div>
          </div>

          {/* Dots */}
          <div className="flex justify-center mt-10 gap-2">
            {slides.map((_, idx) => (
              <button
                key={idx}
                onClick={() => goToSlide(idx)}
                className={`w-2.5 h-2.5 rounded-full ${
                  idx === activeIndex ? 'bg-secondary' : 'bg-[#666]'
                }`}
                aria-label={`Slide ${idx + 1}`}
              />
            ))}
          </div>
        </div>
              </div>
          </div>
      </div>

    );
  }

  export default BrandCarousel